import React, { useState } from 'react';
import './etatmajor.css';
import { ReactComponent as ORGANIGRAMME } from './ORGANIGRAMME.svg'; // Assurez-vous que le chemin est correct
import ListEtatMajorSuccessifs from '../ListEtatMajorSuccessifs';
function PageEtatMajor() {
  const [ExtraitbiographieCema, setExtraitbiographieCema] = useState(false);

  return (
    <div className="">
      <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="titre2">ETAT MAJOR DES ARMEES</div>
            <a href="#" onMouseEnter={() => setExtraitbiographieCema(true)} onMouseLeave={() => setExtraitbiographieCema(false)} className="fondBiographieCema"></a>
            <img src="/images/accueil/accueilCEMA.jpg" className="d-block w-100" alt="..." />

            {/* {ExtraitbiographieCema && (
              <div className="extraitbiographieCema afficherExtraitbiographieCema text-dark ">
                <div className=" p-3 bg-white rounded-lg ">
                  <div className="d-flex justify-content-center">
                    <div className="bg-primary text-center col-md-11">Affectations récentes</div>
                  </div>
                  <br />
                  <b className="text-bold text-primary">xxx</b>
                  : Chef de l Etat-Major des Armées
                  <br />
                  <b className="text-bold text-primary">xxxx</b>
                  : CGP
                  <br />
                  <b className="text-bold text-primary">xxxx</b>
                  : Chef de l Etat-Major auprès de l'Etat-Major Général de l'Armée Malagasy
                  <br />
                  <b className="text-bold text-primary">xxxxx</b>
                  : Directeur des Etudes et de la Formation Militaire auprès de l'Etat-Major Général de l'Armée Malagasy
                  <br />
                  <b className="text-bold text-primary">xxxx</b>: Commandant de l'Ecole Nationale des Sous-Officiers de l'Armée
                </div>
              </div>
            )} */}

            <div className="textmini">
              <div className="d-flex align-items-center justify-content-center">
                <div className="z-index">
                  <a type="button" className="text-primary font-weight-bold" data-toggle="modal" data-target="#exampleModalLong">
                    <div className="col mr-4 " title="LES DATES MARQUANTES DE L'ETAT-MAJOR DES ARMEES">
                      Grandes Dates
                    </div>
                  </a>
                </div>
                <div className="pr-5"></div>
                <div className="pr-5"></div>
                <div className="pr-5"></div>
                <div className="pr-5"></div>
                <div className="pr-5"></div>
                <div className="pr-5"></div>
              </div>
              <div className="modal fade" id="exampleModalLong" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLongTitle">
                        GRANDES DATES DE L’ETAT-MAJOR DES ARMEES
                      </h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <table width="100%">
                        <tr>
                          <td width="65%">
                            <div align="right"></div>
                          </td>
                          <td width="35%">
                            <div align="right">21 Octobre 1958</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">Création du Drapeau National Malagasy</div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">26 Juin 1960</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p align="right">
                              Constitution d’une Armée Nationale formée par deux Régiments InterArmes Malagasy (1° et 2° RIAM) et d’une Gendarmerie.
                              <br />
                              Les deux RIAM étaient placés sous le Commandement du Chef de l’Etat-Major Général des Forces Armées en la personne du Colonel
                              <strong>RAMANANTSOA</strong>.<br />
                              Création des six (06) Régions Militaires (RM)
                            </p>

                            <div align="right">
                              La Première Région Militaire (Antananarivo)
                              <br />
                              La Deuxième Région Militaire (Fianarantsoa)
                              <br />
                              La Troisième Région Militaire (Toamasina)
                              <br />
                              La Quatrième Région Militaire (Mahajanga)
                              <br />
                              La Cinquième Région Militaire (Toliara)
                              <br />
                              La Septième Région Militaire (Antsiranana)
                            </div>
                            <p align="right">L’organisation des Forces Armées a été révisée en 1975. C’est le décret n° 75-269 du 14 novembre de la même année qui fixait la création&nbsp;:</p>

                            <div align="right">
                              <ul>
                                <li>
                                  de l’Armée de Développement (constituée par l’ensemble de l’élément «&nbsp;Terre&nbsp;», du Service Civique et du Régiment du Génie) répartie sur les six Régions
                                  Militaires.
                                </li>
                                <li>
                                  d’une Armée Technique de Développement (formée par l’ensemble de l’élément «&nbsp;Air&nbsp;» et des unités du corps de Marine, et qui constituait les Forces
                                  Aéronavales.
                                </li>
                                <li>
                                  des Forces d’Intervention, constituées par l’ensemble des troupes aéroportées (les compagnies de parachutistes), de pelotons de reconnaissance et d’unités de
                                  fusillers-marins
                                </li>
                                <li>du Premiers Régiments des Transmissions et des Services mis sur pied à partir des unités du Bataillon de Commandement et des Services</li>
                              </ul>
                              des Ecoles de formations militaires
                            </div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">20 Septembre 1975</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">Création de l’Etat-Major de la Défense et de l’Armée Populaire (EMDAP)</div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">1976</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">
                              Création de l’Etat-Major des Forces de Développement (EMFD), l’Etat-Major des Forces d’Intervention de l’Armée (EMFIA) et l’Etat-Major des Forces Aéronavales (EMFAN)
                            </div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">15 Juin 1979</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">
                              Création de l’Etat-Major Général de l’Armée Populaire (EMGAP) comprenant&nbsp;: l’Etat-Major des Forces de Développement (EMFD), l’Etat-Major des Forces d’Intervention de
                              l’Armée (EMFIA) et l’Etat-Major des Forces Aéronavales (EMFAN)
                            </div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">1993</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">Création de l’Etat-Major Général de l’Armée Malagasy (EMGAM)</div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">02 Décembre 2003</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">
                              Création des Commandement des Forces d’Intervention de l’Armée (COFIA), des Forces de Développement (COFOD), des Forces Navales (COFONA) et des Forces Aériennes (COFOA).
                            </div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">11 Mars 2020</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">Création de l’Etat-Major des Armées (EMA), de l’Armée de Terre (EMAT) et de l’Armée de l’Air (EMAA) et de la Marine Nationale (EMMN)</div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">09 Décembre 2020</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">Création des 10 Zones de Défense et de Sécurité (ZDS) et des 22 Délégations Militaires Régionales (DMR)</div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right">10 Février 2021</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right">Création du Groupement des Forces Spéciales d’Intervention (GFSI)</div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div align="right"></div>
                          </td>
                          <td>
                            <div align="right"></div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-outline-warning btn-sm" data-dismiss="modal">
                        Fermer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a className="carousel-control-prev" href="/" role="a" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="/etatmajor" role="a" data-slide=" ">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
        <div className="d-flex justify-content-around">
          <div>
            <a href="#armeedeterre" title="VERS L'ETAT MAJOR DE L'ARMEE DE TERRE" className="text-success">
              <strong>ETAT-MAJOR DE L'ARMEE DE TERRE</strong>
            </a>
          </div>
          <div>
            <a href="#armeedelair" title="VERS L'ETAT MAJOR DE L'ARMEE DE L'AIR" className="text-primary">
              <strong>ETAT-MAJOR DE L'ARMEE DE L'AIR</strong>
            </a>
          </div>
          <div>
            <a href="#marinenationale" title="VERS L'ETAT MAJOR DE LA MARINE NATIONALE" className="text-info">
              <strong>ETAT-MAJOR DE MARINE NATIONALE</strong>
            </a>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-around" width="1400 px">
      <img className="card-img-top " src="/images/cema/ORGANIGRAMME.psd.jpeg" alt="Card image cap" />
        {/* <ORGANIGRAMME /> */}
      </div>
      <div className=" container">
        <div className="pt-4 text-center mb-5 ">
          <h1 className="text-success">LES CHEFS DE L’ETAT-MAJOR SUCCESSIFS</h1>
        </div>
        <ListEtatMajorSuccessifs />
        <div>
          <div className="float-right text-primary">
            <div>
              (<u>Extrait Agenda 2022- DCCA – EIA</u>)
            </div>
          </div>
        </div>
        <div className=" mt-5">
          <div className="elanelana ml-5 text-justify ">
            &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;L’ancienne appellation de l’Etat-Major Général de l’Armée Malagasy a été remplacée par l’Etat-Major des Armées par le Décret n° 2020-316 du
            11 mars 2020 portant Création de l’Etat-Major des Armées. Ont été ensuite instaurés pendant la même année les trois états-majors notamment :
          </div>
        </div>
        <ul>
          <li>
            <i className="fa fa-snowflake-o mt-5" aria-hidden="true"></i>
            L’Etat-Major de l’Armée de Terre
          </li>
          <li>
            <i className="fa fa-snowflake-o mt-5" aria-hidden="true"></i>
            L’Etat-Major de l’Armée de l’Air
          </li>
          <li>
            <i className="fa fa-snowflake-o mt-5" aria-hidden="true"></i>
            L’Etat-Major de la Marine Nationale
          </li>
        </ul>

        <div>
          <div className="elanelana ">
            <div className="ml-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ce processus peut être simplifié comme suit :</div>
          </div>
        </div>
        <div className="col-md-12">
          <img className="card-img-top " src="/images/accueil/Slide1.JPG" alt="Card image cap" />
        </div>
        <div className="row">
          <div className="text-primary ">
            <div className="float-right">
              <u>Schéma simplifié du processus de la Restructuration de l’Armée Légendes</u>
            </div>
          </div>
          <div className="">
            <div className="float-right text-primary">
              <div>
                (<u>Source : Extrait Docs sensibilisation Restructuration</u>)
              </div>
            </div>
          </div>
        </div>

        <div className="elanelana ml-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Les trois Armées deviennent indépendantes tant sur le plan opérationnel que structurel.</div>
        <div id="armeedeterre" className=" bg-success mt-5 mb-5">
          <h2>ETAT-MAJOR DE L’ARMEE DE TERRE</h2>
        </div>
        <div className="bg-warning col-md-4 mb-5">
          <h3>LES GRANDES DATES</h3>
        </div>

        <div className="row">
          <div className="col">
            <table className="table table-bordered" cellSpacing="0" cellPadding="0">
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">04 Mars 1976</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création de l’Inspection Générale de l’Armée Populaire</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">12 Février 1998</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">
                    Création du Premier Régiment de la Région Militaire numéro cinq (1/RM5) à Toliara et du Deuxième Régiment de la Région Militaire numéro cinq (2/RM5) à Taolagnaro et du Troisième
                    Région Militaire numéro cinq (3/RM5) à Morondava.
                  </p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">2 Décembre 2003</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création du Commandement des Forces de Développement (COFOD) et du Commandement des Forces d’Intervention de l’Armée (COFIA).</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">17 Mars 2005</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création du Service Civique.</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">25 Juillet 2006</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création du Service Militaire d’Action au Développement (SMAD).</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">13 Juin 2012</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création du Bataillon de Renforcement des Capacités Africaines pour le Maintien de la Paix (RECAMP).</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">10 Septembre 2013</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création de l’Ecole Nationale des Sous-Officiers de l’Armée (ENSOA).</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">01 Mars 2016</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création Du Corps de Protection Civile (CPC).</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">13 Septembre 2017</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création du 1er Bataillon Interarmes (1er BIA) d’Ihosy.</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">18 Mai 2018</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création du 2ème Bataillon Interarmes (2° BIA) de Tsiroanomandidy.</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">
                    Création du Deuxième Régiment de la Région Militaire Numéro Trois (2/RM3) à Andilamena et du Deuxième Régiment de la Région Militaire Numéro Quatre (2/RM4) à Maintirano.
                  </p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">11 Mars 2020</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création de l’Etat-Major de l’Armée de Terre.</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">06 Janvier 2020</p>
                </td>
              </tr>
              <tr>
                <td width="425" valign="top">
                  <p align="right">Création du 1er Bataillon Parachutiste (1° BAT PARA) par transformation du 1er Régiment des Forces d’Intervention (1° RFI) à Ivato.</p>
                </td>
                <td width="132" valign="top">
                  <p align="right">&nbsp;</p>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className="row float-right">
          <div className="col text-primary">
            (<u>Source : Extrait Agenda 2022 - DCCA – EIA</u>)
          </div>
        </div>
        <div>
          <div className="col mt-5 mb-3 text-justify  elanelana">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Suivant le Décret n°2020-319 du 11 mars 2020 portant création de l’Etat-Major de l’Armée de Terre, le Commandement des Forces
            d’Intervention de l’Armée et le Commandement des Forces de Développement ont été fusionnés en Etat-Major de l’Armée de Terre dirigé actuellement par le Général de Division, RAKOTONIRINA
            Jean Aimé. Sous son commandement direct sont placées les Brigades d’Infanterie et une Brigade d’Appui Spécialisée (créées suivant le Décret n°2020-319 du 11 mars 2020), réparties dans tout
            le territoire de la République de Madagascar et comportant chacune d’entre elles deux ou quatre bataillons.
          </div>
        </div>

        <div id="armeedelair" className=" bg-info mt-5 mb-5">
          <h2>L’ETAT-MAJOR DE L’ARMEE DE L’AIR</h2>
        </div>
        <div className=" bg-warning col-md-4 mb-5">
          <h3>LES GRANDES DATES</h3>
        </div>
        <div>
          <table className="table table-bordered" cellSpacing="0" cellPadding="0">
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">27 Avril 1961</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">
                  Création de la première Escadrille Malagasy (ESCAMA).
                  <br />
                  Donation en aéronefs de la France.
                </p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">1963</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">
                  Retour des premiers groupes de cadres Officiers et Sous-Officiers Malagasy formés, dans le cadre du programme assurant la formation de l’aviation militaire Malagasy initié à partir
                  de 1958, dans les Ecoles et/ou Bases Militaires Françaises, principalement&nbsp;: Salon de Provence, Nîmes, Rochefort, Cognac, Avord ...
                </p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">1966</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Donation en aéronefs de la part de la France.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="604" colSpan="2" valign="top">
                <p align="right">Octobre 1970 – Juillet 1971</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Donation en aéronefs de la part de la France.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">03 Juillet 1967</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">
                  Accession du CNE
                  <strong>RAKOTONIRINA</strong>
                  <strong>Raymond</strong>, premier Commandant de la Première ESCAMA.
                </p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">24 Août 1967</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Création de l’Etablissement Central Spécialisé en Aéronautique (ECSA).</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="604" colSpan="2" valign="top">
                <p align="right">09 Novembre 1971</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">
                  Sortie de l’ADC
                  <strong>DE RABEARISOA Bertrand</strong>, premier mécanicien d’équipage malagasy.
                </p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">17 Août 1973</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Départ définitif des derniers éléments de l’Armée de l’Air Française.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">31 Mai 1975</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">
                  Prise de Commandement du
                  <strong>CDT RABEMANANTSOA Robert</strong>, premier Malagasy Commandant la Base Aéronavale d’Ivato (BANI).
                </p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="604" colSpan="2" valign="top">
                <p align="right">01 Décembre 1975</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">
                  Création des Forces Aéronavales de l’Armée Populaire constituées par l’Etat-Major des Forces Aéronavales (EMFAN) implanté à Antananarivo, la Base Aéronavale d’Antsiranana (BANA) avec
                  un détachement Marine à Mahajanga et la Base Aéronavale d’Ivato.
                </p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="604" colSpan="2" valign="top">
                <p align="right">23 Avril 1976, en Septembre et Octobre 1977</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Dotation d’hélicoptère lourds soviétiques.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="604" colSpan="2" valign="top">
                <p align="right">06 Novembre 1978</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Dotation d’avions de chasse coréens.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">04 Avril 1979</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Dotation d’avions tri réacteur soviétiques.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">Novembre 1978</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">
                  Début de formation du premier contingent des futurs Officiers en URSS (futurs Première Promotion de la Formation des Pelotons Spéciales de Cadres Spécialistes de l’Académie Militaire
                  d’Antsirabe).
                </p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="604" colSpan="2" valign="top">
                <p align="right">24 Septembre 1982</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Création de l’escadre de chasse et de bombardement d’Arivonimamo, devenu Base Aérienne Tactique (BATAC) le 13 Décembre 1984.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">02 Décembre 2003</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Création du Commandement des Forces Aériennes (COFOA) composé de la BANI et de la BATAC.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">11 Mars 2020</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Création de l’Etat-Major de l’Armée de l’Air (EMAA) par la transformation du COFOA.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="132" valign="top">
                <p align="right">27 Janvier 2021</p>
              </td>
            </tr>
            <tr>
              <td width="472" valign="top">
                <p align="right">Création de la Base Aérienne 213 par fusion de la BANI et de la BATAC.</p>
              </td>
              <td width="132" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
          </table>
        </div>
        <div className="float-right text-primary">
          (<u>Source : Extrait Agenda 2022- DCCA – EIA</u>)
        </div>

        <div className="mt-5 text-justify elanelana">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Conformément aux dispositions de l’article 8 du Décret n°2020-317 du 11 mars 2020 portant création de l’Etat-Major de l’Armée de l’Air et de
          la Base Aérienne 213 qui lui est rattachée et créée suivant le Décret n°2021-084 du 27 janvier 2021, par fusion des Base Aéronavale d’Ivato et Base Aérienne Tactique d’Arivonimamo.
          Actuellement, c’est le Général de Brigade Aérienne, ANDRIANARIJAONA Mamy qui est à la tête de cet Etat-Major.
        </div>
        <div id="marinenationale" className="col-md-12 bg-primary mt-5">
          <h2>L’ETAT-MAJOR DE LA MARINE NATIONALE</h2>
        </div>
        <div className="col-md-5 bg-warning mt-5 mb-5">
          <h3>LES GRANDES DATES</h3>
        </div>
        <div>
          <table className="table table-bordered" cellSpacing="0" cellPadding="0">
            <tr>
              <td width="444" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="160" valign="top">
                <p align="right">1er décembre 1975</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">
                  Fusion de l’Elément Mer et de l’Elément Air de l’Armée Malgache.
                  <br />
                  Création des Forces Aéronavales (création de la première Base Aéronavale, située à Ivato Antananarivo, et de la Deuxième Base Aéronavale, à Antsiranana, suivant l’arrêté n°2242 du
                  Président du Conseil Suprême de la Révolution, Chef de l’Etat et du Gouvernement et Ministre de la Défense et des Forces Armées Populaires, en date du 15 Novembre 1975, en
                  application du Décret n°75-269 du 14 Novembre 1975 portant organisation de l’Armée Populaire.
                </p>
              </td>
              <td width="160" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="160" valign="top">
                <p align="right">02 Décembre 2003</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">
                  Signature du Décret n°2003-1118 portant création du Commandement des Forces Navales abrogeant l’arrêté n°2242 du 15 Novembre 1975 portant création des Forces Aéronavales et entamant
                  le processus de séparation de la Marine et de l’Armée de l’Air en deux éléments distincts avec leur commandement respectif.
                </p>
              </td>
              <td width="160" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="160" valign="top">
                <p align="right">11 Mars 2020</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">Création de l’Etat-Major de la Marine Nationale par le Décret N°2020-318</p>
              </td>
              <td width="160" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="160" valign="top">
                <p align="right">06 Janvier 2021</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">Le 2ème BIMA est créé et intègre la Marine Nationale, par la transformation du 2ème RFI, suivant le Décret n° 2021-014.</p>
              </td>
              <td width="160" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="160" valign="top">
                <p align="right">18 Février 1961</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">
                  Création à Antsiranana de l’Elément Mer de l’Armée Malgache constitué par l’Unité de la Marine Malgache, une formation à terre, et le «&nbsp;Tanamasoandro&nbsp;», une unité embarquée
                  (ex-patrouilleur «&nbsp;Marjolaine&nbsp;» de la Marine Française).
                </p>
              </td>
              <td width="160" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="160" valign="top">
                <p align="right">01 Décembre 1975</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">
                  Fusion de l’Elément Mer et de l’Elément Air pour la création des Forces Aéronavales constituées par l’Etat-Major des Forces Aéronavales (EMFAN) implanté à Antananarivo, la Base
                  Aéronavale d’Antsiranana (BANA) avec un détachement Marine à Mahajanga et la Base Aéronavale d’Ivato.
                  <br />
                  Acquisition du RC TROZONA, MAILKA, EDIC AINA VAO, PC TSELATRA et MALAKY, des vedettes chinoises et américaines.
                </p>
              </td>
              <td width="160" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">&nbsp;</p>
              </td>
              <td width="160" valign="top">
                <p align="right">02 Décembre 2003</p>
              </td>
            </tr>
            <tr>
              <td width="444" valign="top">
                <p align="right">Création de l’Etat-Major de la Marine Nationale (EMMN) par la transformation du COFONA.</p>
              </td>
              <td width="160" valign="top">
                <p align="right">&nbsp;</p>
              </td>
            </tr>
          </table>
        </div>
        <div>
          <div className="text-primary float-right">
            (<u>Source : Extrait Agenda 2022- DCCA – EIA</u>)
          </div>
        </div>
        <div>
          <div className="mt-5 text-justify mt-5 elanelana">
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Et enfin, de par le Décret n° 2020-318 du 11 Mars 2020 portant création de l’Etat-Major de la Marine Nationale, le Commandement des
              Forces Navales (COFONA)et devient l’Etat-Major de la Marine Nationale. Il est dirigé par le Contre-Amiral, GA Jacquy Honoré. Aussi, conformément au décret n° 2021-14, le 2ème Bataillon
              d’Infanterie de la Marine (2° BIMA) fut instauré à Antsiranana le 06 Janvier 2021, par la transformation du Deuxième Régiment des Forces d’Intervention (2° RFI).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageEtatMajor;
